/**
 * Price a paid (price-locked) order line must keep while it is edited, as a LINE
 * TOTAL: the ordered unit price × the ordered quantity.
 *
 * `editOrder.targetPrice` is the line's UNIT price (base + add-ons) while the
 * product page's total is unit × quantity — comparing the two directly reported
 * a price mismatch on every line ordered more than once, before anything was
 * changed. The ORDERED quantity is used, not the one in the quantity field: on a
 * locked order a quantity change is a price change (the API rejects it too), so
 * changing it must show the mismatch.
 *
 * Returns null when there is no target (order not locked / nothing to match).
 */
export function lockedLineTarget(editOrder) {
  const unit = editOrder?.targetPrice;
  if (unit == null || Number.isNaN(Number(unit))) return null;
  const quantity = Math.max(1, Math.trunc(Number(editOrder?.quantity)) || 1);
  return Math.round(Number(unit) * quantity * 100) / 100;
}
